/* JOLI POT, page de recherche (assets/jp-recherche.js), chargé par sections/jp-recherche.liquid quand une recherche est faite.
   N'ajoute que des compléments : la page fonctionne sans ce script (produits, articles, pages, occasions par mots-clés en Liquid).
   1. Idées de messages : cherche dans la banque de messages (métaobjets jp_messages, support Pots, rendus par snippets/jp-donnees.liquid),
      sans accents ni majuscules, sur le texte du message et le nom de son thème. Cartes identiques à la page Idées de messages
      (a.jpi__msg > span.jpi__scene + span.jpi__txt, styles snippets/jp-idees-styles.liquid), pot dessiné et loupe par assets/jp-pot-apercu.js (window.JPPOT).
      Lien identique : <fiche du configurateur>?message=<message>&occasion=<thème>.
   2. Occasions : complète avec les collections de la recherche prédictive Shopify (/search/suggest.json, type collection). */
(function () {
  var root = document.querySelector('[data-jprs]');
  if (!root) return;
  var q = (root.getAttribute('data-q') || '').trim();
  if (!q) return;

  function norm(t) {
    return ' ' + String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/œ/g, 'oe').replace(/æ/g, 'ae').replace(/[^a-z0-9]+/g, ' ').trim() + ' ';
  }
  var STOP = ' a au aux de des du d en et l la le les un une mon ma mes ton ta tes son sa ses je j tu t il elle on nous vous me m te pour avec sur pot pots fleur fleurs fleu fl personnalise personnalisee personnalisable cadeau ';
  var ALIAS = { mamy: 'mamie', mami: 'mamie', mammie: 'mamie', papy: 'papi', grandmere: 'mamie', grandpere: 'papi', maitraisse: 'maitresse', anniv: 'anniversaire', bebe: 'naissance', enceinte: 'grossesse', remerciement: 'merci', remerciements: 'merci', thanks: 'thank', bichette: 'copine', bichettes: 'copine', bff: 'copine' };
  var qn = norm(q);
  var toks = qn.trim().split(' ').filter(Boolean).map(function (w) { return ALIAS[w] || w; });
  var sig = toks.filter(function (w) { return w.length > 1 && STOP.indexOf(' ' + w + ' ') < 0; });
  if (!sig.length) sig = toks.filter(function (w) { return w.length > 2; });
  var nbMsg = 0, nbOcc = 0, attente = 0;

  function annonce() {
    if (attente > 0) return;
    /* Compteur et titre « rien trouvé » mis à jour avec ce que le script a ajouté */
    var cp = root.querySelector('[data-jprs-compte]');
    if (cp && (nbMsg || nbOcc)) {
      var n = (parseInt(cp.getAttribute('data-n'), 10) || 0) + nbMsg + nbOcc;
      cp.textContent = (cp.getAttribute(n > 1 ? 'data-plus' : 'data-un') || '').replace('[n]', n);
      var vt = root.querySelector('[data-jprs-vide]');
      if (vt && vt.getAttribute('data-bis')) vt.textContent = vt.getAttribute('data-bis');
    }
    var el = root.querySelector('[data-jprs-annonce]');
    var modele = root.getAttribute('data-annonce') || '';
    if (el && (nbMsg || nbOcc) && modele) el.textContent = modele.replace('[o]', nbOcc).replace('[m]', nbMsg);
  }

  /* 1. Idées de messages */
  function messages() {
    var data = root.querySelector('[data-jprs-data]');
    var sec = root.querySelector('[data-jprs-msgs]');
    var ul = root.querySelector('[data-jprs-msg-l]');
    if (!data || !sec || !ul || !sig.length) return;
    var d;
    try { d = JSON.parse(data.textContent); } catch (e) { return; }
    var exclus = (d.exclus || []).map(function (x) { return x.trim(); });
    var theme = null, saute = false, vus = {}, liste = [];
    String(d.src || '').split('\n').forEach(function (ligne) {
      var t = ligne.trim();
      if (!t) return;
      if (t.charAt(0) === '#') { theme = t.slice(1).trim(); saute = exclus.indexOf(theme) >= 0; return; }
      if (!theme || saute) return;
      var aff = t.replace(/ \/ /g, ' ').replace(/\//g, ' ');
      var n = norm(aff);
      if (vus[n]) return;
      vus[n] = 1;
      liste.push({ brut: t, t: aff, th: theme, n: n, h: norm(theme) });
    });
    var phrase = qn.trim().length >= 3 ? qn.trimEnd() : null;
    /* Mot de 3 lettres ou plus : début de mot (bapt trouve baptême). Mot plus court : mot entier (« ai » ne trouve pas « aime »). */
    function tous(hay) { return sig.every(function (w) { return hay.indexOf(w.length > 2 ? ' ' + w : ' ' + w + ' ') >= 0; }); }
    var res = [];
    liste.forEach(function (m, i) {
      var sc = 0;
      if (phrase && m.n.indexOf(phrase) >= 0) sc = 3;
      else if (tous(m.n)) sc = 2;
      else if (phrase && m.h.indexOf(phrase) >= 0) sc = 1.5;
      else if (tous(m.n + m.h)) sc = 1;
      if (sc) res.push({ m: m, sc: sc, i: i });
    });
    res.sort(function (a, b) { return b.sc - a.sc || a.i - b.i; });
    var max = parseInt(root.getAttribute('data-max'), 10) || 8;
    res = res.slice(0, max);
    if (!res.length) return;
    var pot = root.getAttribute('data-pot') || '';
    var cta = root.getAttribute('data-bouton') || '';
    var mention = root.getAttribute('data-mention') || '';
    var J = window.JPPOT, scenes = [];
    res.forEach(function (r) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'jpi__msg';
      a.href = pot + '?message=' + encodeURIComponent(r.m.t) + '&occasion=' + encodeURIComponent(r.m.th);
      var sc = document.createElement('span');
      sc.className = 'jpi__scene';
      sc.setAttribute('data-msg', r.m.brut);
      var tx = document.createElement('span');
      tx.className = 'jpi__txt';
      tx.textContent = r.m.t;
      a.appendChild(sc); a.appendChild(tx); li.appendChild(a);
      ul.appendChild(li);
      scenes.push(sc);
      if (J && cta) J.loupe(li, sc, { hote: root, message: r.m.brut, mention: mention, href: a.href, cta: cta, differer: true });
    });
    sec.hidden = false;
    function dessiner() { if (!J) return; scenes.forEach(function (sc) { sc.innerHTML = J.svg(sc.getAttribute('data-msg')); }); if (J.replacer) J.replacer(); }
    dessiner();
    if (J && document.fonts && document.fonts.load) document.fonts.load('700 20px "JP Sacramento"').then(function () { J.reset(); dessiner(); }, function () {});
    nbMsg = res.length;
  }

  /* 2. Occasions de la recherche prédictive */
  function occasions() {
    var sec = root.querySelector('[data-jprs-occ]');
    var ul = root.querySelector('[data-jprs-occ-l]');
    if (!sec || !ul || !window.fetch) return;
    var masquer = (sec.getAttribute('data-masquer') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = base + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,body';
    attente++;
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        var cols = j && j.resources && j.resources.results && j.resources.results.collections;
        if (!cols || !cols.length) return;
        var deja = {};
        ul.querySelectorAll('[data-url]').forEach(function (li) { deja[li.getAttribute('data-url').split('?')[0]] = 1; });
        cols.forEach(function (c) {
          var u = String(c.url || '').split('?')[0];
          if (!u || deja[u] || masquer.indexOf(c.handle) >= 0) return;
          deja[u] = 1;
          var li = document.createElement('li');
          li.className = 'jprs__occ-c';
          li.setAttribute('data-url', u);
          var a = document.createElement('a');
          a.href = u;
          var box = document.createElement('span');
          box.className = 'jprs__occ-img';
          var img = c.featured_image && c.featured_image.url ? c.featured_image.url : (c.image && (c.image.url || c.image));
          if (img && typeof img === 'string') {
            var im = document.createElement('img');
            im.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=300';
            im.alt = '';
            im.loading = 'lazy';
            im.width = 150; im.height = 150;
            box.appendChild(im);
          }
          var t = document.createElement('span');
          t.className = 'jprs__occ-t';
          t.textContent = c.title;
          a.appendChild(box); a.appendChild(t); li.appendChild(a);
          ul.appendChild(li);
          nbOcc++;
        });
        if (ul.children.length) sec.hidden = false;
      })
      .catch(function () {})
      .then(function () { attente--; annonce(); });
  }

  messages();
  occasions();
  annonce();
})();
